import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import {
    deleteData,
    getAlert,
    insertData,
    parseCurrency,
    updateData,
    getData,
} from "../../../../utils/SamuiUtils";

const Form = ({ callInitialize, mode, name, formData, setFormData, selectedData }) => {
    const [initialFormData, setInitialFormData] = useState({});

    useEffect(() => {
        const compId = localStorage.getItem("company");
        if (compId) {
            setFormData((prevData) => ({ ...prevData, comp_id: compId }));
        }
    }, [setFormData]);

    useEffect(() => {
        if (mode === "I") {
            const initialData = {
                comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
                Group_Id: 0,
                Group_Name: "",
                Group_Status: "Y",
            };
            setFormData(initialData);
            setInitialFormData(initialData);
        } else if (mode === "U") {
            const initialData = {
                comp_id: parseCurrency(selectedData.Comp_Id, 10),
                Group_Id: parseCurrency(selectedData.Group_Id, 10),
                Group_Name: selectedData.Group_Name,
                Group_Status: selectedData.Group_Status,
            };
            setFormData(initialData);
            setInitialFormData(initialData);
        }
    }, [mode, setFormData, selectedData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleInsert = async () => {
        try {
            const { Group_Id, ...dataToInsert } = formData; // แก้จาก ProdCat_Id → Group_Id
            const fields = Object.keys(dataToInsert).join(", ");
            const values = Object.values(dataToInsert);
            const res = await insertData("Tb_Set_ItmGroup", fields, values);
            if (res?.status === "OK") {
                getAlert("OK", "บันทึกสำเร็จ");
                callInitialize();
            } else {
                getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
            }
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
        }
    };

    const formatValues = (data) => {
        const { Group_Id, ...rest } = data;
        return rest;
    };

    const handleUpdate = async () => {
        try {
            const where = { Group_Id: formData.Group_Id };
            const values = formatValues(formData);
            const res = await updateData("Tb_Set_ItmGroup", values, where);
            if (res) {
                getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
                callInitialize();
            }
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
            return null;
        }
    };

    const handleDelete = async () => {
        try {
            const compId = parseCurrency(window.localStorage.getItem("company"), 10);
            const groupId = parseCurrency(selectedData.Group_Id, 10);
            const linkedTypes = await getData(
                "Tb_Set_ItmType",
                `Group_Id = ${groupId} AND Comp_Id = ${compId}`
            );
            if (linkedTypes && linkedTypes.length > 0) {
                getAlert("FAILED", "ไม่สามารถลบกลุ่มสินค้าได้ เนื่องจากมีประเภทสินค้าถูกผูกอยู่");
                return;
            }

            getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
                if (isConfirm) {
                    await deleteData("Tb_Set_ItmGroup", `WHERE Group_Id = ${groupId} AND Comp_Id = ${compId}`);
                    getAlert("OK", "ลบข้อมูลสำเร็จ");
                    await callInitialize();
                }
            });
        } catch (error) {
            getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
        }
    };

    const confirmAndSubmit = async () => {
        try {
            getAlert('C_DIALOG', 'ยืนยันการบันทึกข้อมูล', async (isConfirm) => {
                if (isConfirm) {
                    await handleSubmit();
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const confirmAndUpdate = async () => {
        try {
            getAlert('C_DIALOG', 'ยืนยันการแก้ไขข้อมูล', async (isConfirm) => {
                if (isConfirm) {
                    await handleUpdate();
                    await callInitialize();
                    window.location.href = '/prodgroup';
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        try {
            if (mode === "I") {
                await handleInsert();
            } else if (mode === "U") {
                await handleUpdate();
            }
            await callInitialize();
            setFormData({
                comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
                Group_Id: 0,
                Group_Name: "",
                Group_Status: "Y",
            });
        } catch (error) {
            getAlert("WARNING", "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว");
            return null;
        }
    };

    return (
        <form>
            <Breadcrumbs
                isShowStatus={mode === "U"}
                items={[
                    { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
                    { name: name, url: "/prodgroup" },
                    { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
                ]}
            />
            <div className="container py-4">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h5 className="mb-3 border-bottom pb-2">{name}</h5>
                        <div className="row g-3">
                            <div className="col-6">
                                <label>ชื่อกลุ่มสินค้า</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Group_Name"
                                    value={formData.Group_Name || ""}
                                    onChange={handleChange}
                                    maxLength={50}
                                />
                            </div>
                            <div className="col-6">
                                <label>สถานะ</label>
                                <select
                                    className="form-select"
                                    name="Group_Status"
                                    value={formData.Group_Status || "Y"}
                                    onChange={handleChange}
                                >
                                    <option value="Y">ใช้งาน</option>
                                    <option value="N">ไม่ใช้งาน</option>
                                </select>
                            </div>
                        </div>

                        <div className="row mt-4">
                            {mode !== "I" ? (
                                <div className="d-flex justify-content-between align-items-center">
                                    <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                                    <div className="d-flex justify-content-end gap-2">
                                        <button onClick={() => (window.location.href = "/prodgroup")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                                        <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-end gap-2">
                                    <button onClick={() => (window.location.href = "/prodgroup")} type="button" className="btn btn-dark btn-lg">ยกเลิก (ESC)</button>
                                    <button onClick={confirmAndSubmit} type="button" className="btn btn-warning text-white btn-lg">บันทึก (F10)</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Form;